import MarketBase from './market-base';
import MarketEmployee from './market-employee';

export default class MarketTariffService extends MarketBase {
    Name: Array<string> = [];
    PrepareTimeSpan: string = "";
    User: Array<MarketEmployee> = [];
}